<div class="mb-3">
  <form [formGroup]="ePayForm">
    <div class="content-container form-comp mb-3">
      <div class="title">
        @if (isWizardForm) {
          <mwp-text-translate text="Billing Information" jsonKey="usaEPayBillingInformation" />
        }
        @if (!isWizardForm) {
          <mwp-text-translate text="Card Holder Information" jsonKey="cardHolderInformation" />
        }
      </div>
      <div class="row content">
        <div class="col-5 mb-3">
          <mwp-input [form]="ePayForm" labelName="First Name" nameForControl="firstName" />
        </div>
        <div class="col-5 mb-3">
          <mwp-input [form]="ePayForm" labelName="Last Name" nameForControl="lastName" />
        </div>
        <div class="col-3 mb-3">
          <mwp-input [form]="ePayForm" labelName="Address 1" nameForControl="homeAddressLine1" />
        </div>
        <div class="col-3 mb-3">
          <mwp-input [form]="ePayForm" labelName="Address 2" nameForControl="homeAddressLine2" />
        </div>
        <div class="col-3 mb-3">
          <mwp-input [form]="ePayForm" labelName="City" nameForControl="homeCity" />
        </div>
        <div class="col-3 mb-3">
          <mwp-dropdown-enum [form]="ePayForm" labelName="State" nameForControl="homeState" [dataEnum]="usStates" />
        </div>
        <div class="col-2 mb-3">
          <mwp-input [form]="ePayForm" labelName="Zip Code" nameForControl="homeZipCode" [maskType]="maskType.zipCode" />
        </div>
        <div class="col-4 mb-3">
          <mwp-input [form]="ePayForm" labelName="Home Email" nameForControl="homeEmail" type="email" />
        </div>
        <div class="col-3 mb-3">
          <mat-checkbox formControlName="sendReceipt" (change)="requireEmail($event)">
            <mwp-text-translate text="Email Receipts" jsonKey="emailReceipts" />
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="content-container mb-3">
      <div class="title">
        @if (isWizardForm) {
          <mwp-text-translate text="Card Information" jsonKey="usaEPayCardInformation" />
        }
        @if (!isWizardForm) {
          <mwp-text-translate text="Credit Card Details" jsonKey="creditCardDetails" />
        }
      </div>
      <div class="row content">
        <div class="col-12 mb-3">
          @if (!cardInfo) {
            <mwp-text-translate text="No credit card on file, please enter a new valid credit card." jsonKey="usaEPayNoCardOnFile" />
          }
          @if (cardInfo) {
            <div>
              <div class="mb-2">
                <mwp-text-translate class="me-1" text="Credit Card:" jsonKey="usaEPayCardOnFile" /> {{ cardInfo }}
              </div>
              @if (isWizardForm) {
                <mwp-text-translate text="Re-enter card information to verify or enter a new card to change the current card." jsonKey="usaEPayNoCardOnFile2" />
              }
              @if (!isWizardForm) {
                <mwp-text-translate text="If you would like to change your credit card info, please enter the updated card below." jsonKey="usaEPayNoCardOnFile3" />
              }
            </div>
          }
        </div>
        <div class="col-6 mb-3">
          <mwp-input [form]="ePayForm" labelName="Card Number" nameForControl="cardNumber" [maskType]="maskType.numericValues" autoComplete="off" />
        </div>
        <div class="col-3 mb-3">
          <mwp-input [form]="ePayForm" labelName="Expiration Date (MM/YY)" nameForControl="cardExpiration" [maskType]="maskType.shortDateCCExpire" autoComplete="off" />
        </div>
      </div>
    </div>
  </form>
</div>
@if (isTestPayServerDisabled) {
  <div class="message-container error mb-3 text-center">
    <div>
      <mwp-text-translate text="Pay server for test, qa, and dev systems are disabled!" jsonKey="testPayServerDisabled" />
    </div>
    <div>
      <mwp-text-translate text="Any data saved is for internal only testing." jsonKey="testPayServerDisabled2" />
    </div>
    <div>
      <mwp-text-translate text="In order to test Pay Server functionality, you will need to test in production when published." jsonKey="testPayServerDisabled3"/>
    </div>
  </div>
}
@if (isWizardForm) {
  <div>
    <mwp-benefit-enrollment-wizard-control [isCheckout]="true" [isContinueDisabled]="ePayForm.invalid" (emitComplete)="complete()" />
  </div>
}
@if (!isWizardForm) {
  <div class="w-100 d-inline-flex justify-content-end">
    <button class="mwp-button-save" [disabled]="ePayForm.invalid" (click)="complete()">
      Save
    </button>
  </div>
}